import Cookies from "js-cookie";

class Service {
  public getCookie(name: string): string | undefined {
    return Cookies.get(name);
  }

  public setCookie(name: string, value: string, days: number, domain?: string): void {
    let expires = "";
    const cookieDomain = domain ? `domain=${domain};` : "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `expires=${date.toUTCString()};`;
    }

    document.cookie = `${name}=${(value || "")};${cookieDomain}${expires}path=/`;
  }

  public removeCookie(name: string, domain?: string): void {
    this.setCookie(name, "", -1, domain);
  }
}

export const CookieService = new Service();
